import React, { FC } from 'react';
import { formatPrice } from '../../utils/format_helper';
import { Link } from '../Link';
import styles from './PromoBlocks.css';
import { IPromo, IPromoLink } from '../../types/promo';
import { Container } from '../Container';
import { MAP_URL } from '../../constants/mapUrl';

interface IPromoBlock {
  promo?: IPromo;
}

export const PromoBlocks: FC<IPromoBlock> = ({ promo }) => {
  return (
    <Container className={styles['inner']}>
      {promo && (
        <div className={styles['promo']} data-name="Promo">
          <div className={styles['image']} />
          <div className={styles['text']}>
            <h5 className={styles['title']}>{promo.title}</h5>
            <ul className={styles['list']}>
              {promo.links.map((promoLink: IPromoLink) => (
                <li key={promoLink.url} className={styles['list-item']}>
                  <Link href={promoLink.url} title={promoLink.h1}>
                    {promoLink.title}
                  </Link>
                  <span className={styles['count']}>{formatPrice(promoLink.objectCount, 4)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      <div className={styles['map']} data-name="MapBlock">
        <div className={styles['map-content']}>
          <span className={styles['map-title']}>Поиск на карте</span>
          <span className={styles['map-text']}>
            Ищите недвижимость рядом с парком, <span className={styles['map-subtext']}>лесом или водоемом</span>
          </span>
          <Link href={MAP_URL} className={styles['map-button']}>
            Найти на карте
          </Link>
        </div>
      </div>
    </Container>
  );
};
